<app-pageheader Title="Search LPR">
</app-pageheader>

<app-datalistview #Datalistview [Columns]="Columns" [PreLoad]="false" [ShowMap]="true" [ShowPaging]="false"
    ApiUrl="parking/lpr/plates/searches" [AllowEdit]="false">
    <app-filter-set>
        <div app-search-filter></div>
        <div app-search-button></div>
    </app-filter-set>
</app-datalistview>